/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CourseFinancialLangViewModelPaginatedResponse } from "../types/CourseFinancialLangViewModelPaginatedResponse.ts";
import { courseFinancialLangViewModelSchema } from "./courseFinancialLangViewModelSchema.ts";

export const courseFinancialLangViewModelPaginatedResponseSchema = z.object({
  data: z.array(z.lazy(() => courseFinancialLangViewModelSchema)).nullish(),
  currentPage: z.optional(z.number().int()),
  totalPages: z.optional(z.number().int()),
  totalCount: z.optional(z.number().int()),
}) as unknown as ToZod<CourseFinancialLangViewModelPaginatedResponse>;
